<template>
  <div class="c-dashboard__card">
    <b-card :title="$t('lang.label_certificate_expiring')"  class="text-center">
      <b-table class="clickable_table" responsive="sm" @row-clicked="viewCertificateDetail" :fields="gridColumns" :items="certificates" show-empty> </b-table>
      <div class="d-flex justify-content-end mt-2" v-if="certificates.length">
        <b-button variant="link" @click="redirectToMyCertificates()">
          <span>{{ $t("lang.label_view_all") }}</span>
        </b-button>
      </div>
    </b-card>
  </div>
</template>
<script>
import moment from "moment";
import * as utils from "../../utils";
export default {
  name: "TopExpiringCertificates",
  data() {
    return {
      certificates: [],
      gridColumns: [
        {
          key: "subjectDn",
          sortable: false,
          label: this.$t("lang.label_certificate_subjectDn"),
          tdClass: "break-text-all"
        },
        {
          key: "validNotAfter",
          sortable: false,
          label: this.$t("lang.label_certificate_validNotAfter"),
          tdClass: this.getVariant,
          formatter: value => {
            return moment(String(value)).format(utils.constants.DATE_PATTERN);
          }
        }
      ]
    };
  },
  methods: {
    getTopExpiringCertificates() {
      this.$store.dispatch("certificate/getTopExpiringCertificates").then(response => {
        this.certificates = response.data;
      });
    },
    redirectToMyCertificates() {
      this.$router.push("/certificates");
    },
    viewCertificateDetail(record) {
      this.$router.push({
        name: "certificate-detail",
        params: { id: record.id }
      });
    },
    getVariant(value) {
      var validTo = moment(value);
      var currentDate = moment(new Date());
      const diff = moment.duration(moment(validTo).diff(moment(currentDate)));
      if (diff.years() === 0 && diff.months() < 1) {
        return "text-warning font-weight-bold";
      } else {
        return "";
      }
    }
  },
  mounted() {
    this.getTopExpiringCertificates();
  }
};
</script>
<style></style>
